const ITEMS = [
  "Scientific & Translational Strategy",
  "Clinical Development",
  "Regulatory Strategy",
  "Organizational & Operational Strategy",
  "Executive & Board Advisory",
  "Connecting Expertise to Advance Science",
];

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="relative bg-[#0B132B] border-y border-white/[0.07] py-5 overflow-hidden"
  >
    <div className="animate-marquee flex whitespace-nowrap w-max">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center" aria-hidden={copy === 1}>
          {ITEMS.map((item) => (
            <span key={`${copy}-${item}`} className="flex items-center">
              <span className="font-serif text-lg sm:text-xl tracking-wide text-slate-400 px-8">
                {item}
              </span>
              <span className="w-1.5 h-1.5 rounded-full bg-teal-500/70 animate-pulse-dot" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
